<app-selector label="Classifications Game" [isEmptySelectable]="isEmptySelectable" [data]="classificationGameCoreService.classificationGameList$| async"
    displayKey="name" [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="classificationGameCoreService.loading"
    [hint]="hint">
</app-selector>